import React from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import VeracodeCredentialsForm from './VeracodeCredentialsForm'
import VeracodeMappingForm from './VeracodeMappingForm'

function VeracodeConfigListing(props) {
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={VeracodeMappingForm}
            CredentialsForm={VeracodeCredentialsForm}
            componentName="Application"
            componentKey="applicationName"
        />
    )
}

export default VeracodeConfigListing
